import { render, staticRenderFns } from "./SuggestionsTable.vue?vue&type=template&id=41e4e340&scoped=true"
import script from "./SuggestionsTable.vue?vue&type=script&lang=js"
export * from "./SuggestionsTable.vue?vue&type=script&lang=js"
import style0 from "./SuggestionsTable.vue?vue&type=style&index=0&id=41e4e340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e4e340",
  null
  
)

export default component.exports